import { requestGet } from '@/common/request';

export interface collectParams {
  channelId: string;
}

export interface collectRes {
  ret: string;
  msg: string;
  data: {};
}

export async function collect(params: collectParams): Promise<collectRes> {
  return await requestGet('/channelActivity/collect', params);
}
